import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import type { ShippingCarrierCreateInput } from "@/modules/shipping/domain/contracts";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useCreateCarrier } from "../api/queries";
import { CarrierForm } from "../ui/CarrierForm";

export function CarrierCreatePage() {
  const nav = useNavigate({ from: "/app/shipping/carriers/new" });
  const createCarrier = useCreateCarrier();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ຜູ້ຂົນສົ່ງ", to: "/app/shipping/carriers" },
            { label: "ສ້າງໃໝ່" },
          ]}
        />
      </Header>
      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="font-bold text-2xl tracking-tight">ສ້າງຜູ້ຂົນສົ່ງ</h2>
            <p className="text-muted-foreground">
              ລະຫັດ (ຕົວໃຫຍ່), ຊື່ 3 ພາສາ, ສະຖານະ, ລຳດັບ.
            </p>
          </div>
          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/shipping/carriers" })}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>
        <div className="mt-6 rounded-xl border bg-card p-6">
          <CarrierForm
            onSubmit={async (values: ShippingCarrierCreateInput) => {
              await createCarrier.mutateAsync(values);
              nav({ to: "/app/shipping/carriers" });
            }}
            onCancel={() => nav({ to: "/app/shipping/carriers" })}
            submitting={createCarrier.isPending}
          />
        </div>
      </Main>
    </>
  );
}
